module.exports = __webpack_public_path__ + "img/13.d0b251cd.jpg";